import type { DocumentTab } from 'features/knowledgeDocumentViewer/types'
import { persistTabState } from 'features/knowledgeDocumentViewer/utils/documentPageSessionStorage'
import { type MutableRefObject, useEffect } from 'react'

/** Debounced + unmount flush of workspace tabs into session storage. */
export function useWorkspaceTabPersistence({
  scope,
  openTabs,
  activeTabId,
  scopeRef,
  openTabsRef,
  activeTabIdRef,
}: {
  scope: string
  openTabs: DocumentTab[]
  activeTabId: string
  scopeRef: MutableRefObject<string>
  openTabsRef: MutableRefObject<DocumentTab[]>
  activeTabIdRef: MutableRefObject<string>
}): void {
  useEffect(() => {
    const timer = window.setTimeout(() => {
      persistTabState(scope, openTabs, activeTabId)
    }, 300)
    return () => window.clearTimeout(timer)
  }, [activeTabId, openTabs, scope])

  useEffect(
    () => () => {
      persistTabState(
        scopeRef.current,
        openTabsRef.current,
        activeTabIdRef.current
      )
    },
    [activeTabIdRef, openTabsRef, scopeRef]
  )
}
